// src/context/ProductVendorContext.js

import React, { createContext, useState, useContext, useCallback  } from 'react';
import { getVendorProducts,updateVendorProduct } from '../services/ProductVendorService'; // adjust path
export const ProductVendorContext = createContext();

export const ProductVendorProvider = ({ children }) => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

const fetchVendorProducts = useCallback(async (userId) => {
  setLoading(true);
  try {
    console.log("Fetching vendor products for user:", userId);
    const vendorData = await getVendorProducts(userId);

    if (Array.isArray(vendorData.data)) {
      setProducts(vendorData.data);
    } else {
      console.warn("vendorData.data is not an array:", vendorData.data);
      setProducts([]);
    }

  } catch (error) {
    console.error('Error fetching vendor products:', error);
    setProducts([]);
  } finally {
    setLoading(false);
  }
}, []);

  const editVendorProduct = useCallback(async (productId, updatedData) => {
    try {
      const response = await updateVendorProduct(productId, updatedData);

      if (response && response.success) {
        // Update local state with the edited product
        setProducts(prevProducts =>
          prevProducts.map(product =>
            product.id === productId ? { ...product, ...updatedData } : product
          )
        );
      } else {
        console.warn('Failed to update product:', response?.message);
      }
    } catch (error) {
      console.error('Error editing vendor product:', error);
    }
  }, []);

  return (
    <ProductVendorContext.Provider
      value={{ products, loading, fetchVendorProducts, editVendorProduct, }}
    >
      {children}
    </ProductVendorContext.Provider>
  );
};

// Optional helper hook
export const useProductVendor = () => useContext(ProductVendorContext);
